const getters = {
    // 获取医生列表
    list1(state) {
        state.list1 = []
        state.list.identityMenuList.forEach(ele => {
            if (ele.managementType == 19) {
                state.list1.push(ele)
            }
        });
        return state.list1
    },
    // 获取护士列表
    list2(state) {
        state.list2 = []
        state.list.identityMenuList.forEach(ele => {
            if (ele.managementType == 20) {
                state.list2.push(ele)
            }
        });
        return state.list2
    },
    // 获取咨询师列表
    list3(state) {
        state.list3 = state.list.empNameList
        return state.list3
    },
    // 获取医助列表
    list4(state) {
        state.list4 = []
        state.list.identityMenuList.forEach(ele => {
            if (ele.managementType == 21) {
                state.list4.push(ele)
            }
        });
        return state.list4
    },
    // 获取耗材列表
    materiaOption(state) {
        return state.list.consumableMenuList
    },
    // 获取项目列表
    productOptions(state) {
        return state.list.projectMenuList
    },
    // 获取录入人列表
    createByList(state) {
        return state.list.createByList
    },
    // 获取信息来源列表
    sourceList(state) {
        return state.list.sourceList
    },
    // 获取院区楼层列表
    areaAndFloorList(state) {
        return state.list.areaAndFloorList
    },
    // 获取仪器列表
    instructmentList(state) {
        return state.list.instrumentMenuList
    },
    // 登记表获取场地列表
    placeList(state) {
        state.placeData = []
        state.reData.forEach(ele => {
            if (ele.menuType == 1) {
                state.placeData.push(ele)
            }
        });
        return state.placeData
    },
    // 登记表麻醉方式
    anesList(state) {
        state.anesList = []
        state.reData.forEach(ele => {
            if (ele.menuType == 2) {
                state.anesList.push(ele)
            }
        });
        return state.anesList
    },
    standList(state) {
        state.standList = []
        state.reData.forEach(ele => {
            if (ele.menuType == 6) {
                state.standList.push(ele)
            }
        });
        return state.standList
    },
    // 登记表外科医生
    doctorList(state) {
        state.doctorList = []
        state.reData.forEach(ele => {
            if (ele.menuType == 13) {
                state.doctorList.push(ele)
            }
        });
        return state.doctorList
    },
    nurseList(state) {
        state.nurseList = []
        state.reData.forEach(ele => {
            if (ele.menuType == 12) {
                state.nurseList.push(ele)
            }
        });
        return state.nurseList
    },
    assistantList(state) {
        state.assistantList = []
        state.reData.forEach(ele => {
            if (ele.menuType == 14) {
                state.assistantList.push(ele)
            }
        });
        return state.assistantList
    },



    place(state) {
        state.place = []
        state.dataAll.forEach(ele => {
            if (ele.menuType == 1) {
                state.place.push(ele)
            }
        });
        return state.place
    },
    skinDoctorList(state) {
        state.skinDoctorList = []
        state.dataAll.forEach(ele => {
            if (ele.menuType == 15) {
                state.skinDoctorList.push(ele)
            }
        });
        return state.skinDoctorList
    },
    skinNurseList(state) {
        state.skinNurseList = []
        state.dataAll.forEach(ele => {
            if (ele.menuType == 16) {
                state.skinNurseList.push(ele)
            }
        });
        return state.skinNurseList
    },
    skinList(state) {
        state.skinList = []
        state.dataAll.forEach(ele => {
            if (ele.menuType == 4) {
                state.skinList.push(ele)
            }
        });
        return state.skinList
    },
    partList(state) {
        state.partList = []
        state.dataAll.forEach(ele => {
            if (ele.menuType == 18) {
                state.partList.push(ele)
            }
        });
        return state.partList
    },
    nurseNoList(state) {
        return state.nurseNoList
    },
    orderList(state) {
        return state.orderList
    },
    orderNurseList(state) {
        state.orderNurseData = []
        state.nurseMenuData.forEach(ele => {
            if (ele.menuType == 12||ele.menuType == 14) {
                state.orderNurseData.push(ele)
            }
        });
        return state.orderNurseData
    },
    orderDoctorList(state) {
        state.orderDoctorData = []
        state.nurseMenuData.forEach(ele => {
            if (ele.menuType == 13) {
                state.orderDoctorData.push(ele)
            }
        });
        return state.orderDoctorData
    },
}
export default getters